import { GetterTree } from "vuex";

import { NationalIdState } from "../types";

const getters: GetterTree<NationalIdState, any> = {
  getNationalIdType: (state) => state.nationalIdType,
  getNationalIdFrontBlob: (state) => state.nationalIdFrontBlob,
  getNationalIdBackBlob: (state) => state.nationalIdBackBlob,
};

export default getters;
